import { EStateUrls } from 'data/urls/states.url';
import { supportedStatesConverter } from 'data/converters/states.converters';
import { TSelectOptionTypeUi } from 'components/Select';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { EPolicyUrls } from 'data/urls/policy.url';
import { isAllStatesPolicyState } from 'data/datas/policyState.data';
import { authSplitApi } from '../helpers/slice.helpers';

const baseUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EPolicyUrls.POLICY}`;

export const statesApi = authSplitApi('states', []).injectEndpoints({
  endpoints: (build) => ({
    getSupportedStates: build.query<TSelectOptionTypeUi[], void>({
      query() {
        return {
          url: `${baseUrl}/${EStateUrls.SUPPORTEDSTATES}`,
          method: 'GET',
        };
      },
      transformResponse: (data: string[]) => {
        return data
          .filter((item) => !isAllStatesPolicyState(item))
          .map((item) => supportedStatesConverter.fromDb(item))
          .sort((a, b) => a.label.localeCompare(b.label));
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetSupportedStatesQuery } = statesApi;
